import {
  createValidation,
  validatorRequired,
  validatorEmail,
  validatorPhone,
  validatorNumber,
} from '../../utils/formValidators';

import { formRegisterContactFields } from '../../constants/formRegister';

export default createValidation([
  {
    name: formRegisterContactFields.CONTACT_PERSON,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: formRegisterContactFields.EMAIL,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorEmail()(field),
    ],
  },
  {
    name: formRegisterContactFields.PHONE,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorPhone()(field),
      (field) => validatorNumber()(field),
    ],
  },
]);
